<template>
  <div class="busReport">
    <div class="busReport__header">
      <div class="busReport__header__back" @click.stop="goToAllCampaign()">
        <span class="busReport__header__back__icon"><i class="adx-ic_arrow_left"></i></span>
        <span class="busReport__header__back__all subhead">Transit Advertising</span>
      </div>
      <div class="busReport__header__title">
        <div class="campaignName">
          <h1 class="medium-title">{{campaign.title}}</h1>
        </div>
        <!-- <div class="busReport__header__button-div">
         <button class="btn-regular secondary">Download</button>
        </div> -->
      </div>
    </div>
    <template>
      <div class="busReport__graph">
        <div class="busReport__graph__header">
          <div class="busReport__graph__header__left">
            <span class="small-title strong"> Overview</span>
          </div>
          <!-- Filter option -->
          <div class="busReport__graph__header__right">
            <div class="filter">
              <dropdown-filter-date v-if="flag" @selected="selectedSort" :list="dateList" labelButton='All Time' :startDate.sync="dateRange.start" :endDate.sync="dateRange.end" />
            </div>
            <div class="group">
              <adx-group-button :list="menuList" @selectedButton="selectedItem" :isDisabled="disabledList"/>
            </div>
          </div>
        </div>
        <!-- Measurement display -->
        <div class="busReport__graph__card">
          <div class="card pointer" :class="{active : toggle.impression}" @click.stop="toggleTo('impression')">
            <div class="card__title small-font">TOTAL IMPRESSIONS</div>
            <template>
              <div v-if="loaded" class="card__number break-word medium-title ">{{ busReport.impression | formatNumber}}</div>
              <div v-else class="card__number large-title">{{ '-' }}</div>
            </template>
          </div>
          <div class="card" :class="{active : toggle.distance}">
            <div class="card__title small-font">TOTAL DISTANCE (KM)</div>
            <template>
              <div class="card__number break-word medium-title ">{{ busReport.total_distance ? displayKilometers(busReport.total_distance) : '-'}}</div>
            </template>
          </div>
          <div class="card pointer" :class="{active : toggle.snap}" @click.stop="toggleTo('snap')">
            <div class="card__title small-font">SNAP IMPRESSIONS</div>
            <template>
              <div class="card__number medium-title ">
                <div class="card__number medium-title ">{{ busReport.snap_impression ? displayPercentage(busReport.snap_impression) : '-' }}</div>
              </div>
            </template>
          </div>
          <div class="card pointer" :class="{active : toggle.fair}" @click.stop="toggleTo('fair')">
            <div class="card__title small-font">FAIR IMPRESSIONS</div>
            <template>
              <div class="card__number medium-title ">{{ busReport.fair_impression ? displayPercentage(busReport.fair_impression) : '-' }}</div>
            </template>
          </div>
          <div class="card pointer" :class="{active : toggle.captive}" @click.stop="toggleTo('captive')">
            <div class="card__title small-font">CAPTIVE IMPRESSIONS</div>
            <template>
              <div class="card__number medium-title ">{{ busReport.captive_impression ? displayPercentage(busReport.captive_impression) : '-' }}</div>
            </template>
          </div>
        </div>
        <!-- Graph display -->
        <div class="busReport__graph__content">
          <adx-line-chart v-if="loaded && !isLoading && !isEmpty" :chartdata.sync="chartData" :options="options" />
          <adx-empty-selection v-else-if="isEmpty && !isLoading" />
          <adx-loading-primary v-else/>
        </div>
      </div>
       <!-- Report display -->
      <div class="busReport__report">
        <div class="busReport__report__sidemenu">
          <ul>
            <router-link tag="li" :to="{name: 'routes'}" class="subhead">Routes</router-link>
            <router-link tag="li" :to="{name: 'vehicle'}" class="subhead">Vehicle</router-link>
            <router-link tag="li" :to="{name: 'coverage'}" class="subhead">Coverage</router-link>
          </ul>
        </div>
        <div class="busReport__report__content">
          <router-view :start_date="startParam" :end_date="endParam" :idParent="id" :key="childParam"/>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import LineChart from '@/components/Chart/LineChart'
import LoadingPrimary from '@/components/Loading/Primary'
import GroupButton from '@/components/GroupButton'
import DropdownDateFilter from '@/components/Dropdown/FilterDateDropdown'
import EmptySelection from '@/components/NotFound/Selection'
import lib from '@/lib/util'
import formatMoney from 'accounting-js/lib/formatMoney.js'
import moment from 'moment'
import axios from 'axios'

import { mapGetters } from 'vuex'
import { formatShortDate, dateFormat } from '@/lib/util'
import { parseErrorGql } from '@/lib/error'

import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-campaignreport-audience',
  components: {
    'adx-line-chart': LineChart,
    'adx-loading-primary': LoadingPrimary,
    'adx-group-button': GroupButton,
    'dropdown-filter-date':DropdownDateFilter,
    'adx-empty-selection': EmptySelection,
  },
  props: {

  },
  data() {
    return {
      id: null,
      report: [],
      chartData: [],
      period: null,
      campaign:{
        title : null,
        start: null,
        end: null,
      },
      start : null,
      end : null,
      today : null,
      aweek : null,
      selected: null,
      loaded: false,
      flag: false,
      isLoading: true,
      selectedDate: '',
      currentType: null,
      currentFilter: null,
      startParam: null,
      endParam: null,
      childParam: null,
      menuList: [
        {
          'id': 0,
          'label': 'Hour',
          'value': 'hour',
        },
        {
          'id': 1,
          'label': 'Day',
          'value': 'day',
        },
        {
          'id': 2,
          'label': 'Week',
          'value': 'week',
        },
        {
          'id': 3,
          'label': 'Month',
          'value': 'month',
        },
      ],
      disabledList: [
        'hour'
      ],
      dateList: [
        {
          'id': 0,
          'label': 'Today',
          'value': 'today',
        },
        {
          'id': 1,
          'label': 'Last 7 Days',
          'value': '7-days',
        },
        {
          'id': 2,
          'label': 'Last 30 Days',
          'value': '30-days',
        },
        {
          'id': 3,
          'label': 'All Time',
          'value': 'alltime',
        },
        {
          'id': 4,
          'label': 'Custom Date',
          'value': 'customdate',
        },
      ],
      toggle: {
        impression: true,
        distance: false,
        snap: false,
        fair: false,
        captive: false,
      },
      busReport:{
        impression: null,
        total_distance: null,
        fair_impression: null,
        snap_impression: null,
        captive_impression: null
      },
      monthsAxis: [],
      options: {
        responsive: true, 
        maintainAspectRatio: false, 
        legend: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              }
            },
          ],
          yAxes: [{
            ticks: {
              //In this callback we can format data displayed at yAxes
              callback: (value, index, values) => {
                return this.getFormatNumber(value);
              },
              // stepSize: 10,
              beginAtZero: true
            }
         }]
        },
      },
      myRange: {
        start: null,
        end: null
      },
      dateRange: {
        start : null,
        end : null
      },
      isMonday : false,
      isAweek : false,
      sunday : null
    }
  },
  computed: {
    ...mapGetters({
      token: 'token'
    }),
    isEmpty: function(){
      return this.report && this.report.length? false: true
    },
    week() {
      let today = new Date();
      today.setDate(today.getDate() - 6)
      return today
    },
    month() {
      let today = new Date();
      today.setDate(today.getDate() - 29)
      return today
    },
  },
  watch: {
    'campaign':{
      handler() {
      if (this.selectedDate == 'customdate')
        this.busReportVehicle()
      },
      deep: true
    },
    'dateRange':{
      handler() {
        if (this.selectedDate == 'customdate'){
          this.campaign.start = this.dateRange.start
          this.campaign.end = this.dateRange.end
        }
      },
      deep: true
    },

  },
  beforeCreate() {
    
  },
  async created() {
    this.currentType = 'impression'
    this.currentFilter = 'day'
    this.selectedDate = 'alltime'
  },
  beforeMount() {
    this.id = this.$route.params.id
  },
  mounted() {
    this.busReportVehicle()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    goToAllCampaign() {
      this.$router.push({ name: 'advertiserbus' })
    },
    async busReportVehicle(){
      // this.isLoading = true
      // let failed = false
      // let res = null
      // try {
      //   res = await this.$apollo.query({
      //     query: require('@/graphql/bus/measurementReport.gql'),
      //     loadingKey:'loading',
      //     errorPolicy:'all',
      //     fetchPolicy:'network-only',
      //     variables:{
      //       id: this.id
      //     }
      //   })
      // } catch(err) {
      //   failed = true
      //   this.$notify({
      //     group: 'saved',
      //     title: 'Error',
      //     text: `Network error!`,
      //     type: 'danger'
      //   });
      //   this.$router.push({ name: `500` })
      // }
      // if (!failed){
      //   if (res.data){
      //     if (res.errors){
      //       const parsedError = await parseErrorGql(res.errors)
      //       if (parsedError.hasError){
      //         if (parsedError.code === 403 || parsedError.code === 404 || parsedError.code === 204){
      //           let code = parsedError.code
      //           if(parsedError.code === 204) code = 404
      //           this.$router.push({name: `${code}`})
      //         } else if(parsedError.code === 502){
      //           this.count++
      //           if (this.count<3){
      //             await this.busReportVehicle()
      //           } else {
      //             this.$notify({
      //               group: 'saved',
      //               title: 'Error',
      //               text: `Something went wrong. Please refresh the page!`,
      //               type: 'danger'
      //             });
      //             this.isLoading = false
      //           }
      //         } 
      //         else {
      //           this.$router.push({ name: `500` })
      //         }
      //       }
      //     }
      //     else {
      //       const { busMeasurementReport } = res.data
      //       if (busMeasurementReport){
      //         this.filterDate(busMeasurementReport)
      //       }
      //     }
      //   }
      // }

      // let data = null

      // axios({
      //   method: 'get',
      //   url: 'http://localhost:3001/measurement-report/13/api/',
      //   headers: {'Authorization': 'c5b801848ca019d45a0c981d1fcc33757ed690e3', 'owner': 117}
      // })
      // .then(function (response) {
      //   data = response.data
      //   this.filterDate(data)
      // });

      // const { data } = await axios.get(`http://128.199.135.58:3001/measurement-report/${this.id}/api/`, { headers: {'Authorization': this.$store.getters.token, 'owner': this.$store.getters.userId} })

      const { data } = await api.get(apiV2.busMeasurement(this.id), { needToken: true })

      this.filterDate(data)
    },
    async filterDate(busMeasurementReport){
      // console.log('a')
      let data = busMeasurementReport
      let campaign = data.busOrder.campaign
      this.period = campaign.period
      let startDate = this.campaign.start
      let endDate = this.campaign.end
      let isStart = false

      if (startDate == null && endDate == null){
        this.campaign = {
          title : campaign.title,
          start : campaign.start,
          end : campaign.end,
        }
        isStart = true
      }
      this.flag = true
      let start = new Date(campaign.start)
      let end = new Date(campaign.end)
      let week = this.week
      let month = this.month
      let day = new Date()
      let today = moment(day).format('YYYY-MM-DD')
      this.today = day
      this.start = campaign.start
      this.end = campaign.end
      
      let filtered = null
      let measurement = data.measurement
      if (this.selectedDate == 'alltime' ){
        filtered = measurement.filter(m => {
          this.campaign.start = start.toString()
          this.campaign.end = end.toString()
          let markerDate = moment(m.measurementId.date).format('YYYY-MM-DD')
          let startFormated = moment(start).format('YYYY-MM-DD')
          let endFormated = moment(end).format('YYYY-MM-DD')
          return markerDate >= startFormated && markerDate <= endFormated
        });
      } else if (this.selectedDate == '7-days'){
        if (isStart){
          this.dateRange.start = campaign.start
          this.dateRange.end = campaign.end
        }
        filtered = measurement.filter(m => {
          this.campaign.start = week.toString()
          this.campaign.end = day.toString()
          let markerDate = moment(m.measurementId.date).format('YYYY-MM-DD')
          let startFormated = moment(week).format('YYYY-MM-DD')
          let endFormated = moment(day).format('YYYY-MM-DD')
          return markerDate >= startFormated && markerDate <= endFormated
        });
      } else if (this.selectedDate == '30-days'){
        filtered = measurement.filter(m => {
          this.campaign.start = month.toString()
          this.campaign.end = day.toString()
          let markerDate = moment(m.measurementId.date).format('YYYY-MM-DD')
          let startFormated = moment(month).format('YYYY-MM-DD')
          let endFormated = moment(day).format('YYYY-MM-DD')
          return markerDate >= startFormated && markerDate <= endFormated
        });
      } else if (this.selectedDate == 'today'){
        filtered = measurement.filter(m => {
          this.campaign.start = today.toString()
          this.campaign.end = today.toString()
          let markerDate = moment(m.measurementId.date).format('YYYY-MM-DD')
          return markerDate == today
        });
      } else if (this.selectedDate == 'customdate'){
        filtered = measurement.filter(m => {
          let convertStart = new Date(startDate)
          let convertEnd = new Date(endDate)
          this.campaign.start = startDate.toString()
          this.campaign.end = endDate.toString()
          let markerDate = moment(m.measurementId.date).format('YYYY-MM-DD')
          let startFormated = moment(convertStart).format('YYYY-MM-DD')
          let endFormated = moment(convertEnd).format('YYYY-MM-DD')
          return markerDate >= startFormated && markerDate <= endFormated
        });
      }
      this.report = filtered
      await this.passProps()
      await this.mapData()
    },
    async mapData() {
      let measurement = this.report
      let measurementType = this.currentType
      let measurementFilter = this.currentFilter
      let period = this.period
      
      let result = []
      let temp_result = []
      let weeks = []
      let days = []
      let months = []
      let label = []
      let graph = []
      let monthsLabel = []
      this.chartData = []
      let totalImpression = 0
      let totalDistance = 0
      let totalSnap = 0
      let totalFair = 0
      let totalCaptive = 0
      this.loaded = false
      this.isMonday = false
      this.isAweek = false

      let start = null
      let end = null
      let day = null
      let sunday = null
      let monthNumber = null
      let firstMonth = null
      let lastMonth = null
      moment.updateLocale('en', {
        week: {
          dow : 1, 
        }
      })

      if(this.selectedDate == 'alltime'){
        start = moment(this.start).week()
        end = moment(this.end).week()
        day = this.createDateRange(this.start, this.end)
        sunday = this.getSunday(this.start, this.end)
        monthNumber = this.getMonths(this.start, this.end)
      } else {
        if (measurement.length == 0){
          let data = {
            id : 1,
            measurementId:{
              snap : 0,
              fair : 0,
              captive : 0,
              distance : 0,
            }
          }
          if (this.selectedDate == 'today'){
            let min = moment(this.start).format('YYYY-MM-DD')
            let max = moment(this.end).format('YYYY-MM-DD')
            let today = moment(this.today).format('YYYY-MM-DD')
            if (today >= min && today <= max) {
              measurement.push({
                ...data
              })
            }
          } else if (this.selectedDate == '7-days'){
            let min = moment(this.start).format('YYYY-MM-DD')
            let max = moment(this.end).format('YYYY-MM-DD')
            let begin = moment(this.week).format('YYYY-MM-DD')
            let last = moment(this.today).format('YYYY-MM-DD')
            if (begin >= min && last <= max) {
              measurement.push({
                ...data
              })
            }
          } else if (this.selectedDate == '30-days'){
            let min = moment(this.start).format('YYYY-MM-DD')
            let max = moment(this.end).format('YYYY-MM-DD')
            let begin = moment(this.month).format('YYYY-MM-DD')
            let last = moment(this.today).format('YYYY-MM-DD')
            if (begin >= min && last <= max) {
              measurement.push({
                ...data
              })
            }
          } else if (this.selectedDate == 'customdate'){
            let min = moment(this.start).format('YYYY-MM-DD')
            let max = moment(this.end).format('YYYY-MM-DD')
            let begin = moment(this.campaign.start).format('YYYY-MM-DD')
            let last = moment(this.campaign.end).format('YYYY-MM-DD')
            if (begin >= min && last <= max) {
              measurement.push({
                ...data
              })
            }
          }
        }
        start = moment(this.campaign.start).week()
        end = moment(this.campaign.end).week()
        day = this.createDateRange(this.campaign.start, this.campaign.end)
        sunday = this.getSunday(this.campaign.start, this.campaign.end)
        monthNumber = this.getMonths(this.campaign.start, this.campaign.end)
      }
      days = day

      firstMonth = monthNumber[0]
      lastMonth = monthNumber[1]

      while (firstMonth <= lastMonth){
        months.push(firstMonth)
        firstMonth++
      }

      while (start <= end){
        weeks.push(start)
        start++
      }

      measurement.forEach(m => {
        let dateFormates = new Date(m.measurementId.date)
        temp_result.push({
          date: dateFormates,
          snap: m.measurementId.snap,
          fair: m.measurementId.fair,
          captive: m.measurementId.captive,
          distance: m.measurementId.distance,
          impression: m.measurementId.snap + m.measurementId.fair + m.measurementId.captive,
        })

        totalDistance += m.measurementId.distance
        totalSnap += m.measurementId.snap
        totalFair += m.measurementId.fair
        totalCaptive += m.measurementId.captive
        totalImpression += m.measurementId.snap + m.measurementId.fair + m.measurementId.captive
      })
      
      this.busReport = {
        total_distance : totalDistance,
        snap_impression : Math.round(totalSnap/totalImpression * 100),
        fair_impression : Math.round(totalFair/totalImpression * 100),
        captive_impression : Math.round(totalCaptive/totalImpression * 100),
        impression : totalImpression
      }
      
      const monthNames = ["January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"]

      if(measurementFilter == 'day') {
        days.forEach(day => {
          let filteredMeasurement = temp_result.filter(obj => lib.dateFormat('YYYY-MM-DD', 'DD MMM', obj.date) == day)

          let snap = filteredMeasurement.reduce((total, current) => total + current.snap, 0)
          let fair = filteredMeasurement.reduce((total, current) => total + current.fair, 0)
          let captive = filteredMeasurement.reduce((total, current) => total + current.captive, 0)
          let distance = filteredMeasurement.reduce((total, current) => total + current.distance, 0)
          let impression = filteredMeasurement.reduce((total, current) => total + current.impression, 0)

          result.push({
            date: day,
            snap: snap,
            fair: fair,
            captive: captive,
            distance: distance,
            impression: impression,
          })
        })
      } else if (measurementFilter == 'month') {
        let s = new Date(this.campaign.start)
        let e = new Date(this.campaign.end)
        let l = new Date(s.getFullYear(), s.getMonth() + 1, 0)
        let startDay = s.getDate()
        let endDay = e.getDate()
        let lastDay = l.getDate()
        let firstDay = 1
        let first = 0
        let last = months.length - 1
        let date = null

        months.forEach(function (month, index) {
          let lastEndDay = new Date(s.getFullYear(), month + 1, 0).getDate()
          let filteredMeasurement = temp_result.filter(obj => obj.date.getMonth() == month)
          
          let snap = filteredMeasurement.reduce((total, current) => total + current.snap, 0)
          let fair = filteredMeasurement.reduce((total, current) => total + current.fair, 0)
          let captive = filteredMeasurement.reduce((total, current) => total + current.captive, 0)
          let distance = filteredMeasurement.reduce((total, current) => total + current.distance, 0)
          let impression = filteredMeasurement.reduce((total, current) => total + current.impression, 0)

          if (startDay != firstDay){
            if (index == first){
              let monthRange = monthNames[month]
              let range = startDay + ' - ' + lastDay
              date = range + ' ' + monthRange 
            } else if (index == last) {
              let monthRange = monthNames[month]
              let range = firstDay + ' - ' + endDay
              date = range + ' ' + monthRange 
            } else {
              let monthRange = monthNames[month]
              let range = firstDay + ' - ' + lastEndDay
              date = range + ' ' + monthRange
            }
          } else {
            let monthRange = monthNames[month]
            let range = firstDay + ' - ' + lastEndDay
            date = range + ' ' + monthRange
          }

          result.push({
            date: date,
            snap: snap,
            fair: fair,
            captive: captive,
            distance: distance,
            impression: impression,
          })
        })

      } else if (measurementFilter == 'week') {
        let index = 0
        let ended = new Date(this.campaign.end)
        let started = new Date(this.campaign.start)
        
        let begin = lib.dateFormat('YYYY-MM-DD', 'DD MMM', started)
        let last = lib.dateFormat('YYYY-MM-DD', 'DD MMM', ended)
        let oneDay = 24*60*60*1000
        let diffDays = Math.round(Math.abs((started.getTime() - ended.getTime())/(oneDay)))

        if (this.selectedDate == '7-days' || diffDays == 6){
          if (started.getDay() != 1){
            this.isAweek = true
            let gate = this.getSunday(started, ended)
            this.sunday = gate[0]
            sunday = []
            sunday.push(begin, last)
          }
          this.isMonday = true
        } else if (last == begin){
          sunday = []
          sunday.push(begin)
        }
        
        while (index < sunday.length){
          weeks.forEach(week => {
            let filteredMeasurement = temp_result.filter(obj => moment(obj.date).week() == week)
            let snap = filteredMeasurement.reduce((total, current) => total + current.snap, 0)
            let fair = filteredMeasurement.reduce((total, current) => total + current.fair, 0)
            let captive = filteredMeasurement.reduce((total, current) => total + current.captive, 0)
            let distance = filteredMeasurement.reduce((total, current) => total + current.distance, 0)
            let impression = filteredMeasurement.reduce((total, current) => total + current.impression, 0)
            
            if(sunday[index] == undefined) {
              sunday[index] = lib.dateFormat('YYYY-MM-DD', 'DD MMM', ended)
            }

            result.push({
              date: sunday[index],
              snap: snap,
              fair: fair,
              captive: captive,
              distance: distance,
              impression: impression,
            })
            index += 1
          })
        }
      }

      label = await Object.keys(result).map((key, index) => {
        return result[key].date
      })
      graph = await Object.keys(result).map((key, index) => {
        return result[key][measurementType]
      })
      if(this.report.length != 0){
        if (measurementFilter == 'month'){
          let titleLabel = label   
          this.options['tooltips'] = {
            titleFontSize : 15,
            bodyFontSize : 15,
            backgroundColor: 'rgba(250,	252, 254)',
            borderColor : 'rgba(0, 0, 0, 0.08)',
            bodyFontColor: '#999999',
            titleFontColor: '#262626',
            borderWidth: 2,
            custom: function(tooltip) {
              if (!tooltip) return;
              tooltip.displayColors = false;
            },
            callbacks: {
              title: function(tooltipItem, data) {
                let label = titleLabel[tooltipItem[0].index]
                return label
              }
            }
          }
          let ticks = this.options.scales.xAxes[0]
          ticks['ticks'] = {
            callback: label => {
              let lastWord = this.getLastWord(label)
              return lastWord
            }
          }
        } else if (measurementFilter == 'week'){
          let starting = new Date(this.campaign.start)
          let startCampaign = lib.dateFormat('YYYY-MM-DD', 'DD MMM', starting)
          let ending = new Date(this.campaign.start)
          let endCampaign = lib.dateFormat('YYYY-MM-DD', 'DD MMM', ending)
          let monday = this.isMonday
          let filter = this.isAweek
          let sundayDate = this.sunday
          let date = new Date(sundayDate)
          date.setDate(date.getDate() + 1)
          let mondayDate = lib.dateFormat('YYYY-MM-DD', 'DD MMM', date)
 
          let titleLabel = label
          if(this.options['tooltips']){
            delete this.options['tooltips']
          } 
          this.options['tooltips'] = {
            titleFontSize : 15,
            bodyFontSize : 15,
            backgroundColor: 'rgba(250,	252, 254)',
            borderColor : 'rgba(0, 0, 0, 0.08)',
            bodyFontColor: '#999999',
            titleFontColor: '#262626',
            borderWidth: 2,
            custom: function(tooltip) {
              if (!tooltip) return;
              tooltip.displayColors = false;
            },
            callbacks: {
              title: function(tooltipItem ,data) {
                let index = tooltipItem[0].index
                let n = data.labels.length
                let label = null

                let lastWeek = titleLabel[tooltipItem[0].index]
                let day = new Date(lastWeek)
                day.setDate(day.getDate() - 6)
                let firstWeek = lib.dateFormat('YYYY-MM-DD', 'DD MMM', day)

                if(n == 1){
                  if(monday){
                    let first = startCampaign 
                    let last = titleLabel[tooltipItem[0].index]
                    label = first + ' - ' + last
                  }
                  else label = titleLabel[tooltipItem[0].index]
                } else {
                  if (filter){
                    if (index == 0){
                      let first = titleLabel[tooltipItem[0].index]
                      let last = sundayDate
                      label = first + ' - ' + last
                    } else if (index == 1){
                      let first = mondayDate
                      let last = titleLabel[tooltipItem[0].index]
                      label = first + ' - ' + last
                    } else label = titleLabel[tooltipItem[0].index]
                  } else {
                    if (index == 0){
                      let sunday = starting.getDay()
                      if (sunday != 0){
                        let first = startCampaign 
                        let last = titleLabel[tooltipItem[0].index]
                        label = first + ' - ' + last
                      } else label = titleLabel[tooltipItem[0].index]
                    } else if (index == 1){
                      let lastCampaign = data.labels[0]
                      let theDay = new Date(lastCampaign)
                      theDay.setDate(theDay.getDate() + 1)
                      let dayStart = lib.dateFormat('YYYY-MM-DD', 'DD MMM', theDay)
                      
                      label = dayStart + ' - ' + lastWeek
                    } else if (index == n-1){
                      let lastCampaign = data.labels[index - 1]
                      let theDay = new Date(lastCampaign)
                      theDay.setDate(theDay.getDate() + 1)
                      let dayStart = lib.dateFormat('YYYY-MM-DD', 'DD MMM', theDay)

                      if (dayStart.toString() == lastWeek.toString) label = lastWeek
                      else label = dayStart + ' - ' + lastWeek
                    } else {
                      label = firstWeek + ' - ' + lastWeek
                    }
                  }
                }
                return label
              }
            }
          }
          
          let ticks = this.options.scales.xAxes[0]
          ticks['ticks'] = {
            callback: label => {
              return label
            }
          }
        } else if (measurementFilter == 'day'){
          let titleLabel = label
          if(this.options['tooltips']){
            delete this.options['tooltips']
          } 
          this.options['tooltips'] = {
            titleFontSize : 15,
            bodyFontSize : 15,
            backgroundColor: 'rgba(250,	252, 254)',
            borderColor : 'rgba(0, 0, 0, 0.08)',
            bodyFontColor: '#999999',
            titleFontColor: '#262626',
            borderWidth: 2,
            custom: function(tooltip) {
              if (!tooltip) return;
              tooltip.displayColors = false;
            },
            callbacks: {
              title: function(tooltipItem ,data) {
                let label = titleLabel[tooltipItem[0].index]
               
                return label
              }
            }
          }
          let ticks = this.options.scales.xAxes[0]
          ticks['ticks'] = {
            maxTicksLimit : 15,
            maxRotation : 0,
            callback: label => {
              return label
            }
          }

            // let index = tooltipItem[0].index
            // let dayEnd = titleLabel[tooltipItem[0].index]
            // let lastCampaign = data.labels[index - 1]
            // let theDay = new Date(lastCampaign)
            // theDay.setDate(theDay.getDate() + 1)
            // let dayStart = lib.dateFormat('YYYY-MM-DD', 'DD MMM', theDay)

            // if (index == 0){
            //   label = dayEnd
            // } else {
            //   label = dayStart + ' - ' + dayEnd
            // }
          
          // let array = this.options.scales.xAxes
          // if (array[1]){
          //   array.pop(array[1])
          // } 
          
          // this.monthsAxis = []
          // let titleLabel = label
          // let array = this.options.scales.xAxes
          // if (array[1]){
          //   array.pop(array[1])
          // }
          // if(this.options['tooltips']){
          //   delete this.options['tooltips']
          // }
          // this.options['tooltips'] = {
          //   titleFontSize : 15,
          //   bodyFontSize : 15,
          //   callbacks: {
          //     title: function(tooltipItem, data) {
          //       let label = titleLabel[tooltipItem[0].index]
          //       return label
          //     }
          //   }
          // }
          

          // label.forEach(obj => {
          //   let m = obj.split(' ').pop()
          //   if (!monthsLabel.includes(m)) {
          //     monthsLabel.push(m)
          //   }
          // })
          // monthsLabel.forEach(obj => {
          //   let mark = null
          //   let filteredLabel = label.filter(x => x.split(' ').pop() == obj)
          //   if(filteredLabel.length == 1) {
          //     mark = filteredLabel[0]
          //   } else {
          //     mark = filteredLabel[Math.round(filteredLabel.length/2)]
          //   }
          //   if (mark.length == 1) mark = '0' + mark
          //   this.monthsAxis.push(mark)
          // })
          
          // let ticks = this.options.scales.xAxes[0]
          // ticks['ticks'] = {
          //   autoSkip: true,
          //   maxTicksLimit : 31,
          //   maxRotation : 0,
          //   callback: label => {
          //     let firstWord = label.replace(/ .*/,'')
          //     return firstWord
          //   }
          // }

          // array.push(
          //   {
          //     id:'xAxis1',
          //     type:"category",
          //     gridLines: {
          //       drawOnChartArea: false,
          //     },
          //     ticks:{
          //       autoSkip: false,
          //       maxRotation : 0,
          //       callback: label => {
          //         let month = label.split(" ")[1]

          //         if (this.monthsAxis.includes(label)) return month
          //       }
          //     }
          //   }
          // )
        }
      }

      this.chartData = {
        labels: label,
        datasets: [
          {
            backgroundColor: 'transparent',
            borderColor: '#FF2D55',
            data: graph
          }
        ]
      }
      this.loaded = true
      this.isLoading = false
    },
    async selectedItem(value){
      this.currentFilter = value
      if(value){
        this.busReportVehicle()
      }
    },
    async selectedSort(item){
      let selected = item.value
      if (selected != this.selectedDate){
        this.selectedDate = selected
        if (selected != 'customdate'){
          this.busReportVehicle()
        }
      }
    },
    async toggleTo(selected) {
      if(selected != this.currentType){
        await Object.keys(this.toggle).map((key, index) => {
          if (key == selected) {
            this.toggle[key] = true
            this.currentType = selected
            this.busReportVehicle()
          } else {
            this.toggle[key] = false
          }
        })
      } 
    },
    passProps(){
      this.startParam = this.campaign.start
      this.endParam = this.campaign.end
      this.childParam = `${this.startParam} - ${this.endParam}`
    },
    displayPercentage(value) {
      return value + '%'
    },
    displayKilometers(value) {
      return this.getFormatNumber(Math.round(value * 10) / 10)
    },
    getFormatNumber(value){
      return formatMoney(value, { symbol: ``, precision: 0, thousand: `.` })
    },
    weekFilter(start) {
      let day = new Date(start);
      day.setDate(day.getDate() + 6)
      return day
    },
    additionalDate(end, add) {
      let day = new Date(end);
      day.setDate(day.getDate() + add)
      return day
    },
    getWeekNumber(date) {
      let day = new Date(date)
      day.setUTCDate(day.getUTCDate() + 4 - (day.getUTCDay()||7))
      let yearStart = new Date(Date.UTC(day.getUTCFullYear(),0,1))
      let weekNo = Math.ceil(( ( (day - yearStart) / 86400000) + 1)/7)
      return weekNo
    },
    createDateRange(startCampaign, endCampaign){
      let start = new Date(startCampaign)
      let end = new Date(endCampaign)
      let dates = []
      while (start <= end) {
          let format = lib.dateFormat('YYYY-MM-DD', 'DD MMM', start)
          dates.push(format)
          start.setDate(start.getDate() + 1)
      }
      return dates
    },
    getSunday(startCampaign, endCampaign) {
      let start = new Date(startCampaign)
      let end = new Date(endCampaign)
      if (start > end) return false
      var date  = start
      var dates = []

      while (date <= end) {
        if (date.getDay() === 0) {
          let format = lib.dateFormat('YYYY-MM-DD', 'DD MMM', date)
          dates.push(format)
        }
        date.setDate(start.getDate() + 1 )
      }
      return dates
    },
    getLastWord(words) {
      let n = words.split(" ")
      return n[n.length - 1]
    }, 
    getMonths(startCampaign, endCampaign){
      let start = new Date(startCampaign)
      let end = new Date(endCampaign)
      let dates = []
      let first = start.getMonth()
      let last = end.getMonth()
      dates.push(first, last)
      return dates
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';

 .busReport__report__content{
   .coverage, .routes, .vehicle{
     max-height: 300px;
      overflow: scroll;
   }
 }

</style>
